import React, { FC } from "react";
import { SOCIALS } from "src/utils/constants";
import "./styles.css";

const Socials: FC<any> = (props:any) => {

  const handleHover = (cmd, id) => {
    const _social = document.getElementById(`s_${props.k}_${id}`);
    if(cmd){
    _social!.style.backgroundImage = `url(${SOCIALS[id]['hover']})`
    }else{
      _social!.style.backgroundImage = `url(${SOCIALS[id]['icon']})`
    }
  }

  return (
    <div className="socials" key={props.key}>
      {SOCIALS.map((s, idx) => (
        <a
          key={`s_${props.k}_${idx}`}
          id={`s_${props.k}_${idx}`}
          style={{
            width:"25px",
            height:"25px",
            backgroundImage: `url(${s.icon})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="change-on-hover"
          onMouseEnter={() => handleHover(1, idx) }
          onMouseLeave={() => handleHover(0, idx)}
          href={s.linkto}
        >
        </a>
      ))}
    </div>
  );
};

export default Socials;
